import React from "react";
import QuickLinks from "./QuickLinks/QuickLinks";

import "./Homepage.scss";
import DreamCard from "./DreamCard/DreamCard";
import DashboardQuizCard from "./Quiz/DashboardQuizCard";
import VerticalProgressBar from "../../Components/VerticalProgressBar/VerticalProgressBar";
import BlogModule from "./BlogModule/BlogModule";
import GreetingCard from "./GreetingCard/GreetingCard";

export default function Homepage() {
  return (
    <div className="homepage_container">
      {/* <Dashboard /> */}
      <GreetingCard />
      <QuickLinks />
      <DashboardQuizCard />
      <DreamCard />
      <VerticalProgressBar />
      <BlogModule />
    </div>
  );
}
